export default __webpack_public_path__ + "static/media/background-img.690cb960.webp";